import { useTranslation } from "react-i18next";
import FoundationEn from "@/agreement/foundation-en.jsx";
import FoundationKo from "@/agreement/foundation-ko.jsx";
import enImage from "@/assets/img/consortium/en.png";
import krImage from "@/assets/img/consortium/kr.png";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "@/assets/sass/introduction-consortium.scss";
const NextIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.1332 7.98372L5.0332 4.88372L6.26654 3.65039L10.5999 7.98372L6.26654 12.3171L5.0332 11.0837L8.1332 7.98372Z" fill="#576059" />
</svg>

function PrivacyPolicy(props) {
  const [activeTab, setActiveTab] = useState(0)
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hash } = useLocation();

  const foundlink = (link, t) => {
    setActiveTab(t)
    navigate("/introduction-consortium" + link);
  };

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="introduction-consortium">
      {/* End Header Section */}
      {/*}
      <div className="cs-height_90 cs-height_lg_80"></div>
      {*/}
      {/* Start Page Head */}
      <div dangerouslySetInnerHTML={{ __html: "<style>html,body{height:100%}</style>" }}></div>

      <section
        className="cs-page_head cs-bg"
        style={{ backgroundImage: "url(/assets/img/donation_title_bg.jpg)", height: "338px", display: "flex", alignItems: "center" }}
      >
        <div className="container">
          <div className="text-center">
            <h1
              className="cs-page_title gmarket"
              style={{
                position: "relative",
                fontSize: 40,
                color: "white",
                fontWeight: "bold"
              }}
            >
              {t("donation")}
            </h1>
          </div>
        </div>
      </section>
      {/* End Page Head */}
      {/*}
      <div className="cs-height_100 cs-height_lg_70"></div>
      {*/}
      <div className="foundation-container container">

        {/*}<div className="container-foundation"></div>{*/}
        {/*}<div className="row">{*/}
        {props.language == "ko" && (
          <div className="page-content">
            <section id="A1">
              <div className="fd_con_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", fontSize: "37px", padding: "37px", lineHeight: "1.4"}}>후원으로 <span style={{color: "rgb(128, 196, 28)", padding: "0 5px"}}>[</span>함께하기<span style={{color: "rgb(128, 196, 28)", padding: "0 5px"}}>]</span></div>
                </h3>
              </div>

              <div className="fd_con_bgpanel">
                <div className="fd_con_pn_desc">
                  <div style={{fontSize: "22px", lineHeight: "1.4", wordBreak: "keep-all", fontWeight: "600", width: "75%", margin: "0 auto"}}>재단법인 기후재단은 <span style={{color:"#80c41c"}}>카본 네거티브(Carbon Negative) 실현을 목표로 하는 공익법인</span>으로, 단순 상쇄(Off Setting)를 넘어 대기 중 탄소를 직접 제거하는 프로젝트를 수행합니다. </div>
                </div>
              </div>
            </section>

            <section className="fd_market" id="A2">
              <div className="fd_market_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", paddingBottom: "20px"}}>기후재단과 함께 하는 기후변화 대응</div>
                  <div style={{textAlign: "center", fontSize:"20px"}}>​“당신의 작은 후원이 지구의 큰 변화를 만듭니다.”​</div>
                  <div style={{textAlign: "center", paddingTop: "20px", fontSize: "20px", fontWeight: "400"}}>기후재단의 프로젝트는 단순히 탄소를 줄이는 것을 넘어, 지역사회와 상생합니다.<br/> 후원을 통한 소중한 참여는 우리 모두를 위한 지속 가능한 미래를 만들어가는데 큰 힘이 됩니다.</div>
                </h3>
              </div>

              <div className="fd_market_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", fontWeight: "600", padding: "50px 0 20px 0", fontSize: "23px"}}>지금 기후재단과 함께 시작하세요!</div>
                </h3>
              </div>

              <div className="fd_market_process">
                <div className="fd_market_process_first">
                  <div className="fd_first_head">

                    <div class="card-grid" style={{maxWidth: "550px", width: "100%", margin: "0 auto", gridTemplateColumns: "none"}}>
                      <div class="card" style={{backgroundColor: "#f2f8f8"}}>
                        <div class="card-desc" style={{textAlign: "center", lineHeight: "1.6", fontSize: "17px"}}>
                          당신의 후원은,<br />
                          공기 중 이산화탄소 저감을 위한 기술 개발과 프로젝트에 사용됩니다.<br />
                          깨끗한 환경과 건강한 생태계를 위한 실질적인 변화를 이루어냅니다.<br />
                          기후 위기 극복의 글로벌 솔루션을 확산하는데 기여합니다.
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div style={{textAlign: "center", paddingTop: "20px", fontSize: "20px", fontWeight: "400"}}>기후 변화에 대응하는 작은 움직임이 세상을 바꿉니다.<br/>후원을 통해 더 나은 지구의 내일을 만들어 갈 수 있습니다.</div>
                    </h3>
                  </div>

                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div style={{textAlign: "center", fontWeight: "600", padding: "50px 0 20px 0", fontSize: "23px", color: "#80c41c"}}>넷제로를 넘어 카본 네거티브로 향하는 여정에 후원으로 함께해 주세요.</div>
                    </h3>
                  </div>

                  <section id="A1">
                    <div className="fd_con_bgpanel">
                      <div className="fd_con_pn_desc" style={{backgroundColor: "#80c41c", display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-start", padding: "25px 42px", gap: "50px"}}>
                        <div class="icon_box" style={{display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", padding: "0 0 0 50px"}}>
                            <img src="/assets/img/donation_icon.svg" />
                        </div>
                        <div class="account_box_inner" style={{display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column", color: "#fff", textAlign: "left"}}>
                            <h3 style={{color: "#fff", fontSize: "24px", padding: "0", margin: "0", fontWeight: "500", paddingBottom: "5px"}}>후원계좌 (KRW)</h3>
                            <p style={{margin: "0", fontSize: "20px", paddingBottom: "10px"}}>국민은행: 039037-04-006457</p>
                            <p style={{margin: "0", fontSize: "20px"}}>예금주 : 재단법인 기후재단</p>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="fd_first_head fd_first_up">
                    <div className="fd_first_head2" style={{textAlign: "center", fontSize: "18px"}}>
                      <p style={{marginBottom: "5px"}}>후원해 주셔서 감사합니다.</p>
                      <p style={{marginBottom: "5px"}}>후원자 정보(이름, 전화번호, E-mail)를 확인할 수 있도록 보내주시기 바랍니다.</p>
                      <p>보내실 곳 : climate@capcotwo.com</p>
                    </div>

                    <div className="fd_first_head2" style={{textAlign: "center", fontSize: "18px"}}>
                      <b>재단법인 기후재단은 비영리 공익법인으로 기부금영수증 발급이 가능하므로, <br/>
                      기부금영수증 발급을 원하시는 후원자/후원기업은 이메일로 요청해 주시기 바랍니다.</b>
                    </div>
                  </div>

                </div>
              </div>
            </section>

          </div>
        )}
        {props.language == "en" && (
          <div className="page-content">
            <section id="A1">
              <div className="fd_con_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", fontSize: "37px", padding: "37px"}}>Join as a <span style={{color: "rgb(128, 196, 28)", padding: "0 5px"}}>[</span>Sponsor<span style={{color: "rgb(128, 196, 28)", padding: "0 5px"}}>]</span></div>
                </h3>
              </div>

              <div className="fd_con_bgpanel">
                <div className="fd_con_pn_desc">
                  <div style={{fontSize: "22px", lineHeight: "1.4", wordBreak: "keep-all", fontWeight: "600", width: "75%", margin: "0 auto"}}>The Climate Foundation is a public-interest nonprofit organization committed to achieving Carbon Negative impact. Going beyond simple carbon offsetting, the Foundation carries out projects that directly remove carbon dioxide from the atmosphere. </div>
                </div>
              </div>
            </section>

            <section className="fd_market" id="A2">
              <div className="fd_market_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", paddingBottom: "20px"}}>Responding to Climate Change Together with the Climate Foundation</div>
                  <div style={{textAlign: "center", fontSize:"20px"}}>​“Your small contribution creates a big change for the planet.”​</div>
                  <div style={{textAlign: "center", paddingTop: "20px", fontSize: "20px", fontWeight: "400"}}>The Climate Foundation’s projects go beyond reducing carbon emissions, they also grow together with local communities.<br/> Your valuable participation through donations becomes a powerful force in creating a sustainable future for all of us.</div>
                </h3>
              </div>

              <div className="fd_market_title">
                <h3 className="fd_con_title_h3">
                  <div style={{textAlign: "center", fontWeight: "600", padding: "50px 0 20px 0", fontSize: "23px"}}>Start now with the Climate Foundation!</div>
                </h3>
              </div>

              <div className="fd_market_process">
                <div className="fd_market_process_first">
                  <div className="fd_first_head">

                    <div class="card-grid" style={{width: "550px", margin: "0 auto", gridTemplateColumns: "none"}}>
                      <div class="card" style={{backgroundColor: "#f2f8f8"}}>
                        <div class="card-desc" style={{textAlign: "center", lineHeight: "1.6", fontSize: "17px"}}>
                          Your Donation is,<br />
                          It is used in technology development and projects to reduce carbon dioxide in the air.<br />
                          Make real changes for a clean environment and a healthy ecosystem.<br />
                          It contributes to the proliferation of global solutions to overcome the climate crisis.
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div style={{textAlign: "center", paddingTop: "20px", fontSize: "20px", fontWeight: "400"}}>Small movements in response to climate change change change changes the world.<br/>Through your donation, you can help create a better tomorrow of the Earth.</div>
                    </h3>
                  </div>

                  <div className="fd_market_title">
                    <h3 className="fd_con_title_h3">
                      <div style={{textAlign: "center", fontWeight: "600", padding: "50px 0 20px 0", fontSize: "23px", color: "#80c41c"}}>Please join us on the journey beyond Net Zero toward Carbon Negative through your support.</div>
                    </h3>
                  </div>

                  <section id="A1">
                    <div className="fd_con_bgpanel">
                      <div className="fd_con_pn_desc" style={{backgroundColor: "#80c41c", display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-start", padding: "25px 42px", gap: "50px"}}>
                        <div class="icon_box" style={{display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center", padding: "0 0 0 50px"}}>
                            <img src="/assets/img/donation_icon.svg" />
                        </div>
                        <div class="account_box_inner" style={{display: "flex", flexWrap: "wrap", justifyContent: "center", flexDirection: "column", color: "#fff", textAlign: "left"}}>
                            <h3 style={{color: "#fff", fontSize: "24px", padding: "0", margin: "0", fontWeight: "500", paddingBottom: "5px"}}>Donation Account (KRW)</h3>
                            <p style={{margin: "0", fontSize: "20px", paddingBottom: "10px"}}>Kookmin Bank: 039037-04-006457</p>
                            <p style={{margin: "0", fontSize: "20px"}}>Account Holder : Climate Foundation</p>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="fd_first_head fd_first_up">
                    <div className="fd_first_head2" style={{textAlign: "center", fontSize: "18px"}}>
                      <p style={{marginBottom: "5px"}}>Thank you for your support</p>
                      <p style={{marginBottom: "5px"}}>Please provide your donor information (name, phone number, and email) for confirmation</p>
                      <p>Send to : climate@capcotwo.com</p>
                    </div>

                    <div className="fd_first_head2" style={{textAlign: "center", fontSize: "18px"}}>
                      <b>The Climate Foundation is a nonprofit public-interest organization and is able to issue donation receipts, <br/>
                      Donors or corporate sponsors who wish to receive a donation receipt are kindly requested to contact us by email.</b>
                    </div>
                  </div>

                </div>
              </div>
            </section>

          </div>
        )}

        {/*}<div className="col-lg-8 offset-lg-2" style={{ wordBreak: "keep-all" }}> 
            {/* {props.language == "ko" && <FoundationKo />}
            {props.language == "en" && <FoundationEn />} */}
        {/*}
            {props.language == "ko" && (
              <img
                src={krImage}
                style={{
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, white 50%, transparent 50%)",
                  position: "relative",
                  zIndex: 2,
                }}
              />
            )}
            {props.language == "en" && (
              <img
                src={enImage}
                style={{
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, white 50%, transparent 50%)",
                  position: "relative",
                  zIndex: 2,
                }}
              />
            )}
            {*/}
        {/*}</div>{*/}
        {/*}</div>{*/}
      </div>
      <div className="cs-height_60 cs-height_lg_30"></div>
      <div className="fd_bottom"></div>
    </div>
  );
}
export default connect((state) => {
  return {
    language: state.language,
  };
})(PrivacyPolicy);
